import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Entity } from '../../objects/entity';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
// import { GlobalDataService } from '../../global-data.service';
// import { ContractManagerService } from '../../service/contract-manager.service';
// import { GoogleSheetsService } from '../../service/google-sheets/google-sheets.service';
import { PermissionsService } from '../../service/permissions/permissions.service';
import { TableDataService } from '../../service/crud-entity-services/table-data.service';
import { ScheduledReportsService } from '../../service/crud-entity-services/scheduled-reports.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ToastMessageDialog } from '../../toolbar-components/toolbar-utilities/view-utilities';
import { PreviewReportComponent } from '../../modules/reports/preview-report/preview-report.component';
import { PeopleService } from '../../service/entity-services/people.service';

import { environment } from '../../../environments/environment';

import * as contractColumns from '../../../app/shared/entity-columns/contract-columns';
import * as grantsColumns from '../../../app/shared/entity-columns/columns-contract-grants';
import * as acuteCareFinancialColumns from '../../../app/shared/entity-columns/contract-acute-financial';
import * as valueColumns from '../../../app/shared/entity-columns/contract-value';
import * as hrColumns from '../../../app/shared/entity-columns/contract-hr';
import * as columnsContractExtensions from '../../../app/shared/entity-columns/contract-extensions';
import * as apColumns from '../../../app/shared/entity-columns/contract-ap';
import * as sochsColumns from '../../../app/shared/entity-columns/contract-sochs-accordion';
import * as salaryAndBenefitsColumns from '../../../app/shared/entity-columns/contract-columns-salary-and-benefits';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';

import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { PickListModule } from 'primeng/picklist';


let _ = require('lodash');
let moment = require('moment');


@Component({
    selector: 'app-new-scheduled-report',
    templateUrl: './new-scheduled-report.component.html',
    styleUrls: ['./new-scheduled-report.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
      AgGridModule,
      FormsModule,
      ReactiveFormsModule,
      MatInputModule,
      MatGridListModule,
      MatCheckboxModule,
      MatExpansionModule,
      MatSlideToggleModule,
      MatSliderModule,
      MatCardModule,
      MatStepperModule,
      MatRadioModule,
      MatSidenavModule,
      MatDividerModule,
      AutoCompleteModule,
      PickListModule
    ]
  })
export class NewScheduledReportComponent extends Entity implements OnInit {

  reportName = null;
  editingExistingReport = false;
  waitingForReportResults = false;

  firstFormGroup?: FormGroup;
  secondFormGroup?: FormGroup;

  newReportFormGroup?: FormGroup;

  dataSourceFormGroup?: FormGroup;
  selectFieldsFormGroup?: FormGroup;
  selectFiltersFormGroup?: FormGroup;

  dateOperatorValue = null;

  filteredLegalEntities = [];
  filteredParties = [];
  filteredContractTypes = [];
  filteredDepartments = [];
  filteredSites = [];
  filteredOwners = [];
  filteredScheduledReportRecipients = [];
  contractTypesValueLabel = [];
  departmentsValueLabel = [];

  contractStatuses = [];
  contractStatusesValueLabel = [];

  renewalTypes = [];
  renewalTypesValueLabel = [];

  chosenColumns = [];
  columnsForReport = [];
  chosenOperators = [];
  chosenValues = [];

  dateOperator = false;
  stringOperator = true;

  allColumns = contractColumns.allColumns;

  numberOperators = [
    '=',
    '!=',
    '<',
    '<=',
    '>',
    '>='
  ]

  booleanOperators = [
    'Yes',
    'No'
  ]

  containsOperators = [
    'contains'
  ]

  stringOperators = [
    'contains',
    'does not contain'
  ];


  userOperators = [
    'contains',
    'does not contain'
  ];


  dateOperators = [
    'equals',
    'is before',
    'is after',
    'is within 30 days',
    'is within 60 days',
    'is within 90 days',
    'is within 180 days',
    'previous 30 days'
  ];


  dataSourceList = [
    'Contracts',
    'Data Table - Contracts',
    // 'User Contract Actions'
  ]

  allFrequencies = [
    'days',
    'weeks'
  ]

  monthlyFrequencies = [
    'day of the month'
  ]

  weeklyFrequencyOptions = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];


  dayOfTheMonth = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th', '13th', '14th',
                  '15th', '16th', '17th', '18th', '19th', '20th', '21st', '22nd', '23rd', '24th', '25th', '26th', 
                  '27th', '28th', '29th', '30th', '31st'];


  distributionMethods = ['Schedule Report', 'Save Report Only'];

  defaultColDef = {
                    resizable: true,
                    sortable: true,
                    filter: true
                  };


  contractColumns = [
    {headerName: 'Report Name', field: 'savedViewName', width: 125 }
  ];

  scheduledReportColumns = [
    {headerName: 'Report Name', field: 'name', width: 125 }
  ];

  currentReportColumns = [];
  selectedCurrentReportColumns = [];

  userStartWithSelection = 'not set';
  selectedView = null;

  listOfSavedReports = [];
  listOfScheduledReports: any[] = [];
  currentReportDataList = [];
  filteredContracts = [];

  savedReportsGridApi = null;
  scheduledReportsGridApi = null;
  currentCustomReportGridApi = null;
  currentCustomReportColumnApi = null;

  allDepartments: any[] = [];
  contractTypes: any = [];

  previewReport = false;

  tableDataColumns = [];

  tableDataChosen = false;

  colContractId = {
                      colId: 'contractId',
                      headerName: 'Contract ID',
                      field: 'contractId',
                      width: 100,
                      sortable: true
                    };

  colUser = {
                        colId: 'user',
                        headerName: 'User',
                        field: 'user',
                        width: 100,
                        sortable: true
                      };


  colAction = {
                        colId: 'action',
                        headerName: 'Action',
                        field: 'action',
                        width: 100,
                        sortable: true
                      };


  actionsCols = [
    this.colContractId,
    this.colUser,
    this.colAction
  ];

  dataSource = null;

  constructor(public dialog: MatDialog,
              public permissionsService: PermissionsService,
              private _formBuilder: FormBuilder,
              private _snackBar: MatSnackBar,
              private router: Router,
              public scheduledReportService: ScheduledReportsService) { 

    super();

  }

  async ngOnInit() {

    this.getStaticFieldValues();

    this.fetchColumnsByEnvironment();

    this.newReportFormGroup = this._formBuilder.group({
      scheduledReportCtrl: ['', Validators.required],
      reportFrequencyCtrl: ['', Validators.required],
      reportFrequencyValueCtrl: [null, Validators.required],
      reportFrequencyValuePredicateCtrl: ['', Validators.required],
      distributionListCtrl: ['', Validators.required],
      reportNameCtrl: ['', Validators.required],
      chosenValuesCtrl: this._formBuilder.array([
        this._formBuilder.control(null)
      ])
    });

    this.dataSourceFormGroup = this._formBuilder.group({
      startingPointSelectionCtrl: ['', Validators.required],
      dataSourceCtrl: ['', Validators.required]
    });
    this.selectFieldsFormGroup = this._formBuilder.group({
      selectFieldsCtrl: ['', Validators.required]
    });
    this.selectFiltersFormGroup = this._formBuilder.group({
      selectFiltersCtrl: ['', Validators.required]
    });

    // this.listOfScheduledReports = await this.scheduledReportService.getScheduledReports();
    this.listOfScheduledReports = this.listOfScheduledReports['scheduledReports'];
  }


  async openReportPreviewDialog() {

    await this.testQuery();

    const dialogRef = this.dialog.open(PreviewReportComponent, {
      width: '1000px',
      height: '650px',
      data: {
              reportPreview: this.currentReportDataList,
              selectedCurrentReportColumns: this.selectedCurrentReportColumns
            }
    });

    // NOT USED - view only
    // dialogRef.afterClosed().subscribe(async result => {

    // });      

  }


  // BUGBUG: not used.  Supposed to replace the section of testQuery and sendAndActivate common code
  async organizeReportResults() {

    // let reportData = [];

    // if (this.previewReport) {
    //   this.previewReport = false;
    // }

    // // console.log('test query selected items: ', this.selectedCurrentReportColumns);

    // for (let i = 0; i < this.selectedCurrentReportColumns.length; i++) {

    //   let queryObject = {
    //     'column': null,
    //     'colId': null,  // was just "id"
    //     'operator': null,
    //     'value': null
    //   }

    //   if (this.selectedCurrentReportColumns[i]) {

    //     // console.log('selected report column: ', this.selectedCurrentReportColumns[i]);
    //     // console.log('value: ', this.newReportFormGroup.value.chosenValuesCtrl);
    //     // console.log('chosenValues: ', this.chosenValues);

    //     queryObject.column = this.selectedCurrentReportColumns[i].field;
    //     queryObject.colId = this.selectedCurrentReportColumns[i].colId;
    //     queryObject.operator = this.chosenOperators[i];
    //     queryObject.value = this.newReportFormGroup.value.chosenValuesCtrl[i];

    //     // console.log('column: ', queryObject.column);
    //     // console.log('operator: ', queryObject.operator);

    //     let columnName = queryObject.column;

    //     if (columnName.toLowerCase().indexOf('date') >= 0 && queryObject.value) {
    //           // console.log('found date column: ', queryObject.value);
    //           let valueAsObject = moment(queryObject.value);
    //           queryObject.value = valueAsObject.format('MM/DD/YYYY');
    //           // console.log('updated date: ', queryObject.value);
    //     }

    //     if (queryObject.column === 'legalEntityFriendlyName') {
    //       queryObject.column = 'legalEntities';
    //     }

    //     if (queryObject.column === 'otherPartiesColumnFriendly') {
    //       queryObject.column = 'otherParties';
    //     }

    //     reportData.push(queryObject);

    //   }
    // }

    // console.log('report data: ', reportData);

    // return reportData;


  }




  async saveAndActivate() {

    let arrayOfScheduledReportQueries = [];

    console.log('*** saveAndActivate columns: ', this.chosenColumns);
    console.log('*** saveAndActivate columns: ', this.selectedCurrentReportColumns);

    // for (let i = 0; i < this.selectedCurrentReportColumns.length; i++) {

    //   let queryObject = {
    //     'column': null,
    //     'colId': null,
    //     'operator': null,
    //     'value': null,
    //     'friendlyName': null
    //   }

    //   if (this.chosenOperators[i]) {
    //       queryObject.column = this.selectedCurrentReportColumns[i].field;
    //       queryObject.colId = this.selectedCurrentReportColumns[i].colId;
    //       queryObject.operator = this.chosenOperators[i];
    //     if (this.newReportFormGroup.value.chosenValuesCtrl[i] === '') {
    //       queryObject.value = null;
    //     } else {
    //       queryObject.value = this.newReportFormGroup.value.chosenValuesCtrl[i];
    //     }
    //     queryObject.friendlyName = this.selectedCurrentReportColumns[i].headerName;
    //   } else {
    //     queryObject.column = this.selectedCurrentReportColumns[i].field;
    //     queryObject.colId = this.selectedCurrentReportColumns[i].colId;
    //     queryObject.operator = null;
    //     queryObject.value = null;
    //     queryObject.friendlyName = this.selectedCurrentReportColumns[i].headerName;
    //   }

    //   arrayOfScheduledReportQueries.push(queryObject);

    // }


    // // CRASHING BUG:
    // // Cannot read property 'getColumnState' of null
    // // try using:  selectedCurrentReportColumns
    // let scheduledReportObject = {
    //   'name': this.newReportFormGroup.value.reportNameCtrl,
    //   'activationDate': (new Date).getTime().toString(),
    //   'creator': this.globalDataService.email,
    //   'schedReportData': arrayOfScheduledReportQueries,
    //   'frequency': this.newReportFormGroup.value.reportFrequencyValuePredicateCtrl,
    //   'value': this.newReportFormGroup.value.reportFrequencyValueCtrl,
    //   'distributionList': this.newReportFormGroup.value.distributionListCtrl,
    //   'viewColumns': this.selectedCurrentReportColumns, // maybe null???
    //   // 'viewColumns': this.currentCustomReportColumnApi.getColumnState(),
    //   'sortModel': null,
    //   // 'sortModel': this.currentCustomReportGridApi.getSortModel(),
    //   'filterModel': null,
    //   // 'filterModel': this.currentCustomReportGridApi.getFilterModel(),
    //   'tableData': this.tableDataChosen
    // }

    // // console.log('about to save this report: ', scheduledReportObject);

    // await this.scheduledReportService.addNewScheduledReport(scheduledReportObject);

    // this.savedReportToast();

    // this.scheduledReportService.loadReportOnInit = scheduledReportObject.name;

    this.router.navigateByUrl('/securehome/reports');
  }


  selectionChange(event) {

    // console.log('mat step event: ', event);

    if (event.selectedIndex === 6) {

      if (!this.previewReport) {
        this.previewReport = !this.previewReport;
        this.testQuery();
      }
    }
  }




  async testQuery() {

    let reportData = [];

    if (this.previewReport) {
      this.previewReport = false;
    }

    // console.log('test query selected items: ', this.selectedCurrentReportColumns);

    // for (let i = 0; i < this.selectedCurrentReportColumns.length; i++) {

    //   let queryObject = {
    //     'column': null,
    //     'colId': null,  // was just "id"
    //     'operator': null,
    //     'value': null
    //   }

    //   if (this.selectedCurrentReportColumns[i]) {

    //     // console.log('selected report column: ', this.selectedCurrentReportColumns[i]);
    //     // console.log('value: ', this.newReportFormGroup.value.chosenValuesCtrl);
    //     // console.log('chosenValues: ', this.chosenValues);

    //     queryObject.column = this.selectedCurrentReportColumns[i].field;
    //     queryObject.colId = this.selectedCurrentReportColumns[i].colId;
    //     queryObject.operator = this.chosenOperators[i];
    //     queryObject.value = this.newReportFormGroup.value.chosenValuesCtrl[i];

    //     // console.log('column: ', queryObject.column);
    //     // console.log('operator: ', queryObject.operator);

    //     let columnName = queryObject.column;

    //     if (columnName.toLowerCase().indexOf('date') >= 0 && queryObject.value) {
    //           // console.log('found date column: ', queryObject.value);
    //           let valueAsObject = moment(queryObject.value);
    //           queryObject.value = valueAsObject.format('MM/DD/YYYY');
    //           // console.log('updated date: ', queryObject.value);
    //     }


    //     // BUGBUG:  There is a copy of this in reports-list.component.  We should have only 1.

    //     if (queryObject.column === 'legalEntityFriendlyName') {
    //       queryObject.column = 'legalEntities';
    //     }

    //     if (queryObject.column === 'otherPartiesColumnFriendly') {
    //       queryObject.column = 'otherParties';
    //     }

    //     if (queryObject.column === 'primaryOwner.friendlyName') {
    //       queryObject.column = 'primaryOwner';
    //     }

    //     if (queryObject.column === 'secondaryOwner.friendlyName') {
    //       queryObject.column = 'secondaryOwner';
    //     }

    //     if (queryObject.column === 'tertiaryOwner.friendlyName') {
    //       queryObject.column = 'tertiaryOwner';
    //     }

    //     if (queryObject.column === 'party.name') {
    //       queryObject.column = 'directVendor';
    //     }

    //     if (queryObject.column === 'parentParty.name') {
    //       queryObject.column = 'parentParty';
    //     }        

    //     reportData.push(queryObject);

    //   }
    // }

    // // console.log('report data: ', reportData);

    // this.waitingForReportResults = true;

    // let reportResponse = null;

    // if (this.dataSource === 'userContractActions') {
    //     // reportResponse = await this.contractManagerService.getContractActions();
    // } else {
    //     reportResponse = await this.contractManagerService.runReportContracts(reportData);
    // }
    // this.waitingForReportResults = false;


    // BUGBUG: Permissions doesn't work because we are not getting the right values for contracts.  For example
    //          we are getting siteFriendlyNames instead of just the sites data field. Not sure where/how to fix this
    //          at the moment and there is a demo tomorrow.  Coming back to this.
    // console.log('report results: ', reportResponse);
    // console.log('PERMISSIONS all contracts: ', this.globalDataService.allContracts);
    // let reportPermissionsFiltered = await this.permissionsService.processContractsThroughPermissions(reportResponse.reportResult);
    // console.log('permissions filtered results: ', reportPermissionsFiltered);

    // console.log('*** REPORT RESPONSE *** ');
    // console.log('report results: ', reportResponse.reportResult);

    // const allPeople = await this.peopleService.getAllPeople();

    // this.currentReportDataList = await this.updateContractFields(reportResponse.reportResult, allPeople);

    // this.previewReport = true;
  }



  savedReportToast(): void {

    // this.globalDataService.toastMessage = 'Report Saved';

    this._snackBar.openFromComponent(ToastMessageDialog, {
      duration: 5000,
    });

  }




  async dataSourceSelected(event) {
    // console.log('dataSourceSelected: ', event);

    // if (event.value === 'Contracts') {
    //   this.dataSource = 'contracts';
    //   this.tableDataChosen = false;
    //   this.chosenColumns = this.allColumns;
    // } else if (event.value === 'Data Table - Contracts') {

    //   this.dataSource = 'dataTableContracts';

    //   this.tableDataChosen = true;

    //   this.tableDataColumns.push(contractColumns.colContractName);
    //   this.tableDataColumns.push(contractColumns.colContractId);
    //   this.tableDataColumns.push(contractColumns.colContractStatus);
    //   this.tableDataColumns.push(contractColumns.colContractEffectiveDate);
    //   this.tableDataColumns.push(contractColumns.colContractExpirationDate);
    //   this.tableDataColumns.push(contractColumns.colSites);
    //   this.tableDataColumns.push(contractColumns.colContractDepartment);
    //   this.tableDataColumns.push(contractColumns.colLegalEntity);
    //   this.tableDataColumns.push(contractColumns.colContractType);
    //   this.tableDataColumns.push(contractColumns.colContractParty);
    //   this.tableDataColumns.push(contractColumns.colPartyContractCoordinator);

    //   let colSubject = {
    //     colId: 'td-Subject-Subject',
    //     headerName: 'Subject',
    //     field: 'tableDataSubject',
    //     width: 50,
    //     sortable: true
    //   };

    //   let colNotes = {
    //     colId: 'td-Note-Note',
    //     headerName: 'Notes',
    //     field: 'tableDataNote',
    //     width: 50,
    //     sortable: true     
    //   };

    //   let colFieldGroup = {
    //     colId: 'dataType',
    //     headerName: 'Field Group',
    //     field: 'dataType',
    //     width: 50,
    //     sortable: true
    //   };

    //   this.tableDataColumns.push(colSubject);
    //   this.tableDataColumns.push(colNotes);
    //   this.tableDataColumns.push(colFieldGroup);

    //   let tableDataFieldObjectArray = [];

    //   tableDataFieldObjectArray = await this.tableDataService.getFieldGroupObjectArray() as [];

    //   console.log('DATA TABLE SELECTED! field group object array: ', tableDataFieldObjectArray);

    //   tableDataFieldObjectArray.forEach( fieldGroup => {

    //     // console.log('field group: ', fieldGroup);

    //     fieldGroup.fieldGroupValues.forEach(element => {

    //       let fieldGroupHeaderId = fieldGroup.fieldGroupHeader.replace(/\s/g, '');

    //       let columnToAdd = {
    //                           colId: 'td-' + fieldGroupHeaderId + '-' + element,
    //                           headerName: fieldGroup.fieldGroupHeader + ' - ' + element,
    //                           field: fieldGroupHeaderId + element,
    //                           width: 50,
    //                           sortable: true
    //                         };

    //       this.tableDataColumns.push(columnToAdd);

    //     });

    //   })

    //   this.chosenColumns = this.tableDataColumns;
    //   console.log('chosen columns: ', this.chosenColumns);

    // } else if (event.value === 'User Contract Actions') {
    //   this.dataSource = 'userContactActions';
    //   this.tableDataChosen = false;
    //   this.chosenColumns = this.actionsCols;
    // }

    // if (this.chosenColumns) {
    //   this.chosenColumns.forEach( (column) => {
    //     // console.log('adding column: ', column);
    //     this.columnsForReport.push(false);
    //     this.chosenOperators.push(null);
    //     this.chosenValues.push(null);
    //     (this.newReportFormGroup.controls.chosenValuesCtrl as FormArray).push(this._formBuilder.control(''));
    //     this.currentReportColumns = this.currentReportColumns.concat(column);
    //   })
    // }

    // // console.log('current report columns should be populated: ', this.currentReportColumns);

  }


  fieldsReordered() {

    console.log('target reordered');
    // this.chosenOperators = [];
    // this.chosenValues = [];

    // this.chosenColumns.forEach( (column) => {
    //   // console.log('adding column: ', column);
    //   this.columnsForReport.push(false);
    //   this.chosenOperators.push(null);
    //   this.chosenValues.push(null);
    //   (this.newReportFormGroup.controls.chosenValuesCtrl as FormArray).push(this._formBuilder.control(''));
    //   this.currentReportColumns = this.currentReportColumns.concat(column);
    // })

  }



  togglePreviewReport() {

    this.previewReport = !this.previewReport;
  }


  filterScheduledReportRecipients(event) {

    this.filteredScheduledReportRecipients = [];

    // this.filteredScheduledReportRecipients = this.globalDataService
    //                                               .allUsers
    //                                               .filter(option => 
    //                                                       option.friendlyName
    //                                                             .toLowerCase()
    //                                                             .includes(event.query.toLowerCase()));
  }




  onSavedReportsCellClicked(event) {
    console.log('event: ', event);
    console.log('event data: ', event.data);
    console.log('event data saved view data: ', event.data.savedViewData);

    // this.selectedView = event.data.savedViewName;

    // this.chosenColumns = [];

    // if ((event.data.savedViewData != undefined) &&
    //     (Array.isArray(event.data.savedViewData))) {

    //       event.data.savedViewData.forEach(element => {
    //         // console.log('field: ', element.colId);

    //         let foundColumn = _.find(this.allColumns, ['colId', element.colId]);

    //         if (foundColumn != undefined) {
    //           this.chosenColumns = this.chosenColumns.concat(foundColumn);
    //           this.columnsForReport.push(false);
    //           this.chosenOperators.push(null);
    //           this.chosenValues.push(null);
    //           (this.newReportFormGroup.controls.chosenValuesCtrl as FormArray).push(this._formBuilder.control(''));
    //           this.currentReportColumns.push(foundColumn);
    //         }
    //       });
    //     }

    // if (this.currentCustomReportColumnApi != undefined) {
    //   this.currentCustomReportColumnApi.resetColumnState();
    //   this.currentCustomReportGridApi.sizeColumnsToFit();
    // }

  }


  filterContractTypes(event) {

    this.filteredContractTypes = [];

    // this.filteredContractTypes = this.contractTypes.filter(option => option.toLowerCase().includes(event.query.toLowerCase()));
  }



  getStaticFieldValues() {

    // this.googleSheetsService
    //   .getDepartments()
    //   .then(sheetsResponse => {
    //     // // console.log('sheets response --> ', sheetsResponse);
    //     this.allDepartments = sheetsResponse.values[0];
    //     this.allDepartments.forEach( department => {

    //         let valueLabelObject = {
    //           value: department,
    //           label: department
    //         }

    //       this.departmentsValueLabel.push(valueLabelObject);
    //     })
    //   });

    // this.googleSheetsService
    //   .getContractTypes()
    //   .then(sheetsResponse => {
    //     this.contractTypes = sheetsResponse.values[0];
    //     this.contractTypes.forEach( type => {
    //       let valueLabelObject = {
    //         value: type,
    //         label: type
    //       }

    //       this.contractTypesValueLabel.push(valueLabelObject);
    //     })
    //   });

    //   this.googleSheetsService
    //     .getContractStatusTypes()
    //     .then(sheetsResponse => {
    //       this.contractStatuses = sheetsResponse.values[0];
    //       this.contractStatuses.forEach( status => {
    //         let valueLabelObject = {
    //           value: status,
    //           label: status
    //         }

    //         this.contractStatusesValueLabel.push(valueLabelObject);
    //       })
    //   });

    //   this.googleSheetsService
    //     .getRenewalTypeLabels()
    //     .then(sheetsResponse => {
    //       this.renewalTypes = sheetsResponse.values[0];
    //       this.renewalTypes.forEach( status => {
    //         let valueLabelObject = {
    //           value: status,
    //           label: status
    //         }

    //         this.renewalTypesValueLabel.push(valueLabelObject);
    //       })
    //   });

  }


  operatorChanged(event, index) {
    // console.log('event: ', event);
    // console.log('index: ', index);
    // this.chosenOperators[index] = event.value;
  }




  toggleIncludeInReport(index) {
    // this.columnsForReport[index] = !this.columnsForReport[index];

    // console.log('columns: ', this.chosenColumns);
    // console.log('toggle include in report: ', this.currentReportColumns);
    // console.log('selected current report columns: ', this.selectedCurrentReportColumns);

    // this.selectedCurrentReportColumns = [];

    // console.log('current report columns: ', this.currentReportColumns);

    // this.columnsForReport.forEach( (column, index) => {
    //   // console.log('column value for ' + index + ' value is: ', column);
    //   if (column === true) {
    //     this.selectedCurrentReportColumns.push(this.currentReportColumns[index]);
    //   }
    // });

    // console.log('selected columns: ', this.selectedCurrentReportColumns);

    // if (this.currentCustomReportGridApi != undefined) {
    //   this.currentCustomReportGridApi.sizeColumnsToFit();
    //   this.currentCustomReportGridApi.redrawRows();  
    // }

  }



  // BUGBUG - this should be in a parent object.  Edit report needs it too.
  fetchColumnsByEnvironment() {

    let addTheseToAllColumns = [];

    // if (environment['salaryAndBenefits']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(salaryAndBenefitsColumns.allColumns);
    // }

    // if (environment['sochsAccordion']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(sochsColumns.allColumns);
    // }

    // if (environment['acuteCareFinancial']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(acuteCareFinancialColumns.allColumns);
    // }

    // if (environment['value']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(valueColumns.allColumns);
    // }

    // if (environment['grants']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(grantsColumns.allColumns);
    // }

    // if (environment['hrAccordion']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(hrColumns.allColumns);
    // }

    // if (environment['salaryAndBenefits']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(columnsContractExtensions.allColumns);
    // }

    // if (environment['apAccordion']) {
    //   addTheseToAllColumns = addTheseToAllColumns.concat(apColumns.allColumns);
    // }

    // this.allColumns = contractColumns.allColumns.concat(addTheseToAllColumns);

    // this.allColumns = _.sortBy(this.allColumns, ['headerName']);

  }




  startingPointRadioButtonChanged(event) {
    // console.log('event: ', event);
    this.userStartWithSelection = event.value;
  }

  onSavedReportsGridReady(params) {
    this.savedReportsGridApi = params.api;
    // this.savedReportsGridApi.sizeColumnsToFit();
  }

  onExistingScheduledReportsGridReady(params) {
    this.scheduledReportsGridApi = params.api;
    // this.scheduledReportsGridApi.sizeColumnsToFit();
  }

  currentCustomReportGridReady(params) {
    this.currentCustomReportGridApi = params.api;
    this.currentCustomReportColumnApi = params.columnApi;
    // this.currentCustomReportGridApi.sizeColumnsToFit();
  }

}
